<template>
  <div>
    <v-card>
      <v-card-title>
      <v-icon color="primary">
        mdi-cash-multiple
      </v-icon>
        <span class="px-2">{{$t('redemptions')}}</span>
      </v-card-title>
      <v-data-table
        :no-data-text="$t('noData')"
        :no-results-text="$t('noResults')"
        item-key="id"
        :loading="isLoading"
        :loading-text="$t('loading_text')"
        :headers="translatedHeaders"
        :items="redemptions"
        :search="search"
        :footer-props="footerProps"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('search')"
            class="mx-4"
          ></v-text-field>
        </template>

        <template v-slot:item.date="{ item }">
          <small>{{ item.date | moment("LL") }}</small>
        </template>

        <template v-slot:item.user_id="{ item }">
          <a @click.stop="displayUser(item.user_id)">{{
            item.user_name
          }}</a>
        </template>

        <template v-slot:item.redemption_preference="{ item }">
          <v-chip
            :color="getRedemptionPreferenceColor(item.redemption_preference)"
            @click="displayRedemptionPreference(redemptions.indexOf(item))"
            dark
          >
            {{ getRedemptionPreferenceValue(item.redemption_preference) }}
            <v-icon class="ml-2">
              {{ getIconOfRedemptionPreference(item.redemption_preference) }}
            </v-icon>
          </v-chip>
        </template>

      </v-data-table>
    </v-card>

  </div>
</template>

<script>
import auth from '@/services/AuthService'
export default {
  components: {},
  data() {
    return {
      redemptions: [],
      isLoading: false,
      search: "",
      headers: [
        { text: "id", value: "id", align: "start", filterable: false },
        { text: "user_name", value: "user_id" },
        { text: "redemption", value: "redemption_preference" },
        { text: "amount", value: "redemption_amount" },
        { text: "date", value: "date" },
      ],
    };
  },
  computed: {
    translatedHeaders() {
      return this.headers.map(header => ({
        ...header,
        text: this.$t(header.text)
      }));
    },
    footerProps() {
      return {
        itemsPerPageText: this.$t("rows_per_page"),
      }
    }
  },
  mounted() {
    this.fetchRedemptions()
  },
  methods: {
    getIconOfRedemptionPreference(redemption_preference)
    {
      if(redemption_preference==2)
      {
        return "mdi-bank";
      }
      else if(redemption_preference==3)
      {
        return "mdi-credit-card";
      }
      else if(redemption_preference==4)
      {
        return "mdi-credit-card-multiple";
      }
      else
      {
        return "mdi-cash";
      }
    },
    getRedemptionPreferenceColor(redemption_preference)
    {
      if(redemption_preference==2)
      {
        return "primary";
      }
      else if(redemption_preference==3)
      {
        return "info";
      }
      else if(redemption_preference==4)
      {
        return "secondary";
      }
      else
      {
        return "success";
      }
    },
    getRedemptionPreferenceValue(redemption_preference)
    {
      if(redemption_preference==2)
      {
        return this.$t("bank");
      }
      else if(redemption_preference==3)
      {
        return this.$t("paypal");
      }
      else if(redemption_preference==4)
      {
        return this.$t("mobile_money");
      }
      else
      {
        return this.$t("cash");
      }
    },
    displayRedemptionPreference(index) {
      this.$swal({
        title: this.showRedemptionTitle(index),
        html: this.showRedemptionDetails(index),
        icon: "info",
      });
    },
    showRedemptionTitle(index)
    {
      let redemption_preference = this.redemptions[index].redemption_preference;
      if(redemption_preference==2)
      {
        return '<h2>' + this.$t("bank_account") + '</h2>';
      }
      else if(redemption_preference==3)
      {
        return '<h2>' + this.$t("paypal_account") + '</h2>';
      }
      else if(redemption_preference==4)
      {
        return '<h2>' + this.$t("mobile_money_account") + '</h2>';
      }
      else
      {
        return '<h2>' + this.$t("cash_account") + '</h2>';
      }
    },
    showRedemptionDetails(index)
    {
      let redemption_preference = this.redemptions[index].redemption_preference;
      if(redemption_preference==2)
      {
        return '<ul><li><b>' + this.$t("bank_name") + ':</b> ' + this.redemptions[index].redemption_details.bank_name + '</li>' +
        '<li><b>' + this.$t("account_number") + ':</b> ' + this.redemptions[index].redemption_details.account_number + '</li>' +
        '<li><b>' + this.$t("beneficiary_name") + ':</b> ' + this.redemptions[index].redemption_details.beneficiary_name + '</li>' +
        '<li><b>' + this.$t("beneficiary_address") + ':</b> ' + this.redemptions[index].redemption_details.beneficiary_address + '</li>' +
        (this.redemptions[index].redemption_details.iban != null ? '<li><b>' + this.$t("iban") + ':</b> ' + this.redemptions[index].redemption_details.iban + '</li>' : '') +
        (this.redemptions[index].redemption_details.swift != null ? '<li><b>' + this.$t("swift") + ':</b> ' + this.redemptions[index].redemption_details.swift + '</li>' : '') +
        (this.redemptions[index].redemption_details.routing_number != null ? '<li><b>' + this.$t("routing_number") + ':</b> ' + this.redemptions[index].redemption_details.routing_number + '</li>' : '') +
        (this.redemptions[index].redemption_details.bic != null ? '<li><b>' + this.$t("bank_identification_code") + ':</b> ' + this.redemptions[index].redemption_details.bic + '</li>' : '') +
        '</ul>';
      }
      else if(redemption_preference==3)
      {
        return "<b>" + this.$t("paypal") + ":</b> " + this.redemptions[index].redemption_details.email;
      }
      else if(redemption_preference==4)
      {
        return '<ul><li><b>' + this.$t("phone_number") + ':</b> ' + this.redemptions[index].redemption_details.phone_number + '</li>' +
        '<li><b>' + this.$t("network") + ':</b> ' + this.redemptions[index].redemption_details.network + '</li>' +
        '<li><b>' + this.$t("Name") + ':</b> ' + this.redemptions[index].redemption_details.name + '</li>' +
        '</ul>';
      }
      else
      {
        return "";
      }
    },
    displayUser(user_id) {
      this.$router.push({ name: "view-user", params: { user_id: user_id } });
    },
    fetchRedemptions() {
      this.isLoading = true;
      this.redemptions = [];
      axios
        .get('/users/redemptions')
        .then((response) => {
          this.redemptions = response.data;
          console.log(response.data);
        })
        .catch((error) => {
          this.$notify({
            title: this.$t("Error"),
            text: this.$t("error_retrieving_payment_details"),
            type: "error",
          });
          console.log(error);
          auth.checkError(error.response.data.message, this.$router, this.$swal);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover{
  cursor: pointer;
  background: rgba($primary-shade--light, 0.15) !important;
}
</style>
